/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, TouchableOpacity } from 'react-native';

import Colors from '@global/colors';

import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';

const defaultPhoto = require('@/assets/img/default/image-default.png');

const ProductResult = ({
  product = {},
  remove = true,
  border = true,
  onRemove,
}) => {
  return (
    <View
      style={{
        width: '100%',
        padding: 15,
        flexDirection: 'row',
        alignItems: 'center',
        ...(border
          ? { borderBottomWidth: 1, borderBottomColor: Colors.grey0 }
          : {}),
      }}>
      <View
        style={{
          width: '20%',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Image
          source={`${product.image ? product.image : defaultPhoto}`}
          style={{ width: 36, height: 36 }}
          width={36}
          height={36}
        />
      </View>
      <View style={{ width: '80%' }}>
        <SociollaText type="medium" style={{ fontSize: 13 }}>
          {product?.brand?.name ? `${product.brand.name} - ` : ''}
          {product.name}
        </SociollaText>
        <SociollaText style={{ fontSize: 12, color: Colors.grey1 }}>
          [{product.sku ? product.sku : '-'}]
        </SociollaText>
      </View>
      {remove ? (
        <TouchableOpacity onPress={() => onRemove()}>
          <Image
            width={8}
            height={8}
            style={{ width: 8, height: 8 }}
            svg={true}
            source={require('@assets/img/icons/close-grey.svg')}
          />
        </TouchableOpacity>
      ) : (
        false
      )}
    </View>
  );
};
export default ProductResult;
